import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { SourceEntity } from '../../../source/source-entity';
import { Timezone, TypeGuard } from '@principle-theorem/shared';
import { flow, isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';

export const PATIENT_MEDICAL_CONDITION_TYPE = 'patientMedicalCondition';

export const PATIENT_MEDICAL_CONDITION_SOURCE_ENTITY = SourceEntity.init({
  metadata: {
    label: 'Patient Medical Condition List',
    description: '',
    idPrefix: PATIENT_MEDICAL_CONDITION_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface ID4WPatientMedicalCondition {
  patient_id: number;
  condition_id: number;
  description: string;
}

export interface ID4WPatientMedicalConditionFilters {
  patient_id: string;
}

export function isD4WPatientMedicalCondition(
  item: unknown,
  logError: boolean
): item is ID4WPatientMedicalCondition {
  return TypeGuard.interface<ID4WPatientMedicalCondition>(
    {
      patient_id: isNumber,
      condition_id: isNumber,
      description: isString,
    },
    logError
  )(item);
}

export type D4WPatientMedicalCondition = ISourceEntityTypes<
  ID4WPatientMedicalCondition,
  object,
  ID4WPatientMedicalConditionFilters
>;

const PATIENT_MEDICAL_CONDITION_SOURCE_QUERY = `
SELECT
  pat_id AS patient_id,
  med_cond_id AS condition_id,
  med_conditions.description AS description
FROM pat_med_cond
LEFT JOIN med_conditions ON med_conditions.id = pat_med_cond.med_cond_id
WHERE pat_id IS NOT NULL`;

export class PatientMedicalConditionSourceEntity extends BaseSourceEntity<D4WPatientMedicalCondition> {
  sourceEntity = PATIENT_MEDICAL_CONDITION_SOURCE_ENTITY;
  entityResourceType = PATIENT_MEDICAL_CONDITION_TYPE;
  sourceQuery = PATIENT_MEDICAL_CONDITION_SOURCE_QUERY;
  verifySourceFn = isD4WPatientMedicalCondition;

  override transformDataFn = flow([]);

  translate(): object {
    return {};
  }

  getSourceLabel(data: ID4WPatientMedicalCondition): string {
    return `${data.patient_id}-${data.condition_id}`;
  }

  getSourceRecordId(data: ID4WPatientMedicalCondition): string {
    return `${data.patient_id}-${data.condition_id}`;
  }

  getFilterData(
    data: ID4WPatientMedicalCondition,
    _timezone: Timezone
  ): ID4WPatientMedicalConditionFilters {
    return { patient_id: data.patient_id.toString() };
  }
}
